import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/cultural-platform.css';

const ArtsFilmsCulture = () => {
  return (
    <div className="article-page" data-testid="arts-films-culture-page" style={{ background: '#FFFFFF' }}>
      {/* Hero */}
      <section style={{
        padding: '120px 24px 80px',
        background: '#FFFFFF',
        borderBottom: '1px solid #DADCE0'
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <h1 style={{
            fontFamily: 'Google Sans, Roboto, sans-serif',
            fontSize: 'clamp(36px, 5vw, 56px)',
            fontWeight: '400',
            color: '#202124',
            marginBottom: '24px'
          }}>
            Arts, Films & Culture
          </h1>
          <p style={{
            fontSize: '18px',
            color: '#5F6368',
            lineHeight: '1.7'
          }}>
            The roots and living identity of every nation
          </p>
        </div>
      </section>

      {/* Article Content */}
      <section style={{ padding: '80px 24px', background: '#FFFFFF' }}>
        <article style={{ maxWidth: '720px', margin: '0 auto' }}>
          <div style={{
            fontFamily: 'Roboto, sans-serif',
            fontSize: '18px',
            lineHeight: '1.9',
            color: '#202124'
          }}>
            <p style={{ marginBottom: '32px' }}>
              Arts, films and culture are not just creative expressions — they are the roots and living identity 
              of every nation. They carry the stories, values, traditions and emotions that connect people across 
              generations, even as the world rapidly advances through technology.
            </p>
            
            <div style={{
              background: '#F8F9FA',
              padding: '32px',
              borderRadius: '8px',
              marginBottom: '32px',
              borderLeft: '4px solid #1A73E8'
            }}>
              <p style={{ 
                margin: 0,
                fontSize: '20px',
                color: '#202124'
              }}>
                A country may grow through innovation and development, 
                but it is remembered and respected through the culture it shares with the world.
              </p>
            </div>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: '24px',
              marginBottom: '32px'
            }}>
              <div style={{
                background: '#FFFFFF',
                padding: '32px',
                borderRadius: '8px',
                border: '1px solid #DADCE0',
                textAlign: 'center'
              }}>
                <h3 style={{ 
                  fontFamily: 'Google Sans, Roboto, sans-serif',
                  fontSize: '20px',
                  fontWeight: '500',
                  color: '#202124',
                  marginBottom: '12px'
                }}>Films</h3>
                <p style={{ margin: 0, color: '#5F6368', fontSize: '15px' }}>
                  Shape perception and tell our stories
                </p>
              </div>
              <div style={{
                background: '#FFFFFF',
                padding: '32px',
                borderRadius: '8px',
                border: '1px solid #DADCE0',
                textAlign: 'center'
              }}>
                <h3 style={{ 
                  fontFamily: 'Google Sans, Roboto, sans-serif',
                  fontSize: '20px',
                  fontWeight: '500',
                  color: '#202124',
                  marginBottom: '12px'
                }}>Art</h3>
                <p style={{ margin: 0, color: '#5F6368', fontSize: '15px' }}>
                  Preserves heritage for generations
                </p>
              </div>
              <div style={{
                background: '#FFFFFF',
                padding: '32px',
                borderRadius: '8px',
                border: '1px solid #DADCE0',
                textAlign: 'center'
              }}>
                <h3 style={{ 
                  fontFamily: 'Google Sans, Roboto, sans-serif',
                  fontSize: '20px',
                  fontWeight: '500',
                  color: '#202124',
                  marginBottom: '12px'
                }}>Culture</h3>
                <p style={{ margin: 0, color: '#5F6368', fontSize: '15px' }}>
                  Builds pride, unity and meaning
                </p>
              </div>
            </div>

            <p style={{ marginBottom: '32px' }}>
              And when these are celebrated globally, they create understanding, admiration, 
              and positive influence — strengthening relationships between nations through 
              inspiration, not force.
            </p>

            <div style={{
              background: '#1A73E8',
              color: '#FFFFFF',
              padding: '40px 32px',
              borderRadius: '8px',
              marginBottom: '32px',
              textAlign: 'center'
            }}>
              <p style={{ 
                margin: 0,
                fontSize: '20px'
              }}>
                The world may remember a nation for its economy, power or progress —
                <br />but it falls in love with a nation through its culture.
              </p>
            </div>

            <p style={{ marginBottom: '32px' }}>
              The art we create, the films we tell stories through, 
              the traditions we carry, and the music that defines our emotions — 
              these are the things that outlive generations.
            </p>

            <p style={{ marginBottom: '32px' }}>
              Culture is the soft language of diplomacy.
              It's how people connect without even speaking the same words.
            </p>

            <div style={{
              background: '#F8F9FA',
              padding: '32px',
              borderRadius: '8px',
              textAlign: 'center'
            }}>
              <p style={{ 
                margin: 0,
                fontSize: '18px',
                color: '#202124'
              }}>
                When we celebrate arts, films, and culture, we are not just preserving heritage — 
                we are shaping how the world sees us.
              </p>
            </div>
          </div>

          {/* Navigation */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingTop: '48px',
            borderTop: '1px solid #DADCE0',
            marginTop: '48px'
          }}>
            <Link to="/one-shared-responsibility" style={{
              color: '#1A73E8',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '500'
            }}>
              ← Previous: One Shared Responsibility
            </Link>
            <Link to="/" style={{
              color: '#1A73E8',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '500'
            }}>
              Back to Home →
            </Link>
          </div>
        </article>
      </section>
    </div>
  );
};

export default ArtsFilmsCulture;
